import React from 'react';

import { Container } from '@components/Container';
import { Layout } from '@components/Layout';
import { makeMuiStyles, useCommonStyles } from '@styles/index';
import { createStrings } from '@utils/local';

const strings = createStrings({
  ja: {
    title: '【重要】ゴールデンウイークのスケジュールについて',
    date: '2023.04.17',
    content: () => (
      <>
        <p>
          【ご案内】
          <br />
          平素よりD2Dサービスをご利用いただき、誠にありがとうございます。
          <br />
          ゴールデンウイークのスケジュールは下記のとおり予定しております。
          <br />
          <br />
          尚、本件に関しご不明な点がございましたら、弊社営業担当までお問い合せ下さい。
          <br />
        </p>

        <p style={{ textAlign: 'center' }}>記</p>

        <p style={{ textAlign: 'end' }}>以上</p>
      </>
    ),
  },
});

const useStyles = makeMuiStyles((theme, common) => ({
  title: {
    ...common.normalText,
    textAlign: 'center',
    fontWeight: 700,
    fontSize: 30,
    lineHeight: '42px',
    marginBottom: '6rem',
  },
  content: {
    ...common.normalText,
    ...common.textGray700,
  },
  scheduleTableTitle: {
    ...common.textAlignCenter,
    ...common.textGray700,
    ...common.bigText,
    ...common.fontWeight600,
    padding: '22px 0px',
  },
  scheduleTableContainer: {
    ...common.flexColumn,
    padding: 28,
    border: `1px solid ${theme.palette.grey[700]}`,
    rowGap: '1rem',
  },
  scheduleTable: {
    ...common.middleText,
    display: 'grid',
    gridTemplateColumns: 'repeat(6, auto)',
    '& div': {
      ...common.textAlignCenter,
      padding: '10px 8px',
      borderBottom: `1px solid ${theme.palette.grey[400]}`,
    },
  },
}));

interface ScheduleTableProps {
  city: string;
  title: string;
  table: string[][];
}

const ScheduleTable = (props: ScheduleTableProps) => {
  const { city, title, table } = props;

  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  return (
    <div>
      <div className={classes.scheduleTableTitle}>{title}</div>

      <div className={classes.scheduleTable}>
        <div>{city}倉庫荷受けCUT日</div>
        <div>上海ETD</div>
        <div>東京ETA</div>
        <div>大阪ETA</div>
        <div>名古屋ETA</div>
        <div>日本の最短納品日</div>

        {table.map((row) =>
          row.map((cell, i) =>
            cell === 'NO SERVICE' ? (
              <div key={i} style={{ gridColumn: 'span 6' }} className={classes.textError}>
                {cell}
              </div>
            ) : (
              <div key={i}>{cell}</div>
            ),
          ),
        )}
      </div>
    </div>
  );
};

export const GoldenWeek2023 = () => {
  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  return (
    <Layout title={strings.title}>
      <Container>
        <div className={classes.title}>
          {strings.title}
          <br />
          <span className={classes.normalText}>{strings.date}</span>
        </div>
        <div className={classes.content}>{strings.content()}</div>

        <div className={classes.scheduleTableContainer}>
          <ScheduleTable
            city="上海"
            title="ゴールデンウイークスケジュール - D2D航路"
            table={[
              ['2023/04/25', '2023/04/28', '2023/05/01', '', '', '2023/05/09'],
              ['2023/04/27', '2023/04/30', '', '2023/05/02', '', '2023/05/10'],
              ['2023/04/27', '2023/04/30', '', '', '2023/05/03', '2023/05/10'],
              ['NO SERVICE'],
              ['2023/05/02', '2023/05/05', '2023/05/08', '', '', '2023/05/11'],
              ['2023/05/02', '2023/05/05', '', '2023/05/08', '', '2023/05/11'],
              ['2023/05/02', '2023/05/05', '', '', '2023/05/08', '2023/05/11'],
            ]}
          />

          <ScheduleTable
            city="広東"
            title="ゴールデンウイークスケジュール - D2D SHENZHEN+ 航路"
            table={[
              ['2023/04/23', '2023/04/28', '2023/05/01', '', '', '2023/05/09'],
              ['2023/04/25', '2023/04/30', '', '2023/05/02', '', '2023/05/10'],
              ['2023/04/25', '2023/04/30', '', '', '2023/05/03', '2023/05/10'],
              ['NO SERVICE'],
              ['2023/04/30', '2023/05/05', '2023/05/08', '', '', '2023/05/11'],
              ['2023/04/30', '2023/05/05', '', '2023/05/08', '', '2023/05/11'],
              ['2023/04/30', '2023/05/05', '', '', '2023/05/08', '2023/05/11'],
            ]}
          />
        </div>
      </Container>
    </Layout>
  );
};
